<template>
  <div class="carPark-list" :style="{height: height+'px'}">
    <!-- <button @click="addInfo">入场信息</button>
    <button @click="outInfo">出场信息</button> -->
    <loading v-if="loadingImg"></loading>
    <div class="order_ul" :hidden="loadingImg">
      <div class="head_img">
        <!-- <img src="../../assets/img/userInfo_bg.png" alt=""> -->
      </div>
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
        <div class="order_item" v-for="(item,index) in list" :key="index" @click="toCarParkDetail(item.carPlate,item.payStatus,item)">
          <div class="item_title" :style="{border:foldArr.includes(index)?'0':''}">
            <div class="title_text">
              <!-- <span class="order_item_title">{{item.payStatus?'已缴费订单':'待缴费订单'}}{{item.payStatus?`(订单号:${item.orderSn})`:''}}</span> -->
              <span class="order_item_title">{{item.payStatus?'停车缴费订单':'待缴费订单'}}</span>
              <!-- <span class="title_desc">(订单号:2020010375)</span> -->
            </div>
            <div class="order_action" @click.stop="openOrFold($event)" :data-id="index">
              <img :style="{transform:foldArr.includes(index)?'rotate(180deg)':''}" src="../../assets/iconImage/arrowDown.png" alt="">
            </div>
          </div>

          <div class="foldBox" :style="{height:foldArr.includes(index)?'0px':''}">
            <div class="item_content">
              <div class="content_num">
                <span class="left_text">车牌号</span>
                <span>{{item.carPlate}}</span>
              </div>
              <div class="content_parkName">
                <span class="left_text">停车场</span>
                <span>{{item.address}}</span>
              </div>
              <div class="content_enterTime">
                <span class="left_text">入场时间</span>
                <span>{{item.inTime | dCreateTime}}</span>
              </div>
              <div class="content_rule" v-if="item.payStatus">
                <span class="left_text">出场时间</span>
                <span>{{item.endTime | dCreateTime}}</span>
              </div>
              <div class="content_rule" v-else>
                <span class="left_text">收费规则</span>
                <span>{{item.feeRule}}</span>
              </div>
            </div>
            <div class="item_bottom_inPay" v-if="item.payStatus">
              <span class="left_text">实际支付</span>
              <span>￥{{item.orderMoney/100}}</span>
            </div>
            <div class="item_bottom">
              <div class="bottom_search" v-if="!item.payStatus">
                <span>停车缴费查询</span>
                <img src="../../assets/img/green_arrow.png" alt="">
              </div>
              <div class="bottom_show" v-else>
                <span>点击查看</span>
                <img src="../../assets/img/ic_more.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div v-if="isEmpty">
        <div class="empty_img">
          <img src="../../assets/img/data_empty.png" alt="" />
          <div class="empty_text">暂无车辆缴费订单</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '@/components/loading';
export default {
  data() {
    return {
      // 页面整体高度
      height: 0,
      // gif加载动画是否显示
      loadingImg: true,
      //list加载动画
      loading: false,
      // list全部加载是否完成
      finished: false,
      // list 数据源
      list: [],
      pageNumber: 0,
      // 已折叠的订单 下标 数组
      foldArr: [],
      isEmpty: false,
      finishedText: '没有更多了...'
    };
  },
  components: {
    Loading,
  },
  mounted() {

    document.title = '停车场订单列表';
    this.height = document.documentElement.clientHeight;
    //获取停车场订单
    // this.getOrderList();
    this.onLoad();
  },
  methods: {
    /**
     * 获取停车场订单列表
     */
    getOrderList() {
      let formData = new FormData();
      formData.append('pageNumber', this.pageNumber);
      formData.append('pageSize', 10);
      this.$request.post(`/appserver/v1/carPark/getOrderList`, formData).then(res => {
        let repData = res.data.data;
        // for(let i in repData){
        //   repData[i].payStatus = 1
        // }
        this.list = this.list.concat(repData);
        this.loading = false;
        this.loadingImg = false;
        if (repData.length < 10) {
          this.finished = true;
        }
        // this.list = [];
        if (this.list.length === 0 && this.pageNumber === 1) {
          this.isEmpty = true;
          this.finishedText = '';
        }
      })
    },

    /**
     * 订单样式展开/收起事件
     */
    openOrFold(event) {
      let index = event.currentTarget.dataset.id;
      if (this.foldArr.includes(parseInt(index))) {
        this.foldArr.splice(this.foldArr.indexOf(parseInt(index)), 1);
      } else {
        this.foldArr.push(parseInt(index));
      }

      console.log(this.foldArr, 'foldArr')

    },


    /**
     * list 上拉加载事件
     */
    onLoad() {
      this.pageNumber++;
      this.getOrderList();
      console.log('触发onload');
    },

    addInfo() {
      let formData = new FormData();
      formData.append('carPlate', '陕CCG818');
      this.$request.post(`/appserver/v1/carPark/testInPark`, formData).then(res => {
        console.log(res, '入场信息');
      })
    },

    outInfo() {
      let formData = new FormData();
      formData.append('carPlate', '陕CCG818');
      this.$request.post(`/appserver/v1/carPark/testOutPark`, formData).then(res => {
        console.log(res, '出场信息');
      })
    },

    /**
     * 跳转详情页
     */
    toCarParkDetail(carPlate, type, item) {
      if (type) {
        this.$router.push({
          path: '/carParkDetail',
          query: {
            isConfim: true,
            address: item.address,
            carPlate: carPlate,
            orderSn: item.orderSn,
            inTime: item.inTime,
            endTime: item.endTime,
            feeRule: item.feeRule,
            orderMoney: item.orderMoney,
            payMoney: item.payMoney,
            payId: item.payId,
          }
        })
      } else {
        // return;
        this.$router.push({
          path: '/carParkDetail',
          query: {
            carPlate: carPlate
          }
        })
      }

    }
  },
  filters: {
    dCreateTime(value) {
      var date = new Date(parseInt(value));
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      var h = (date.getHours() >= 10 ? date.getHours() : '0' + date.getHours()) + ':';
      var m = (date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes()) + ':';
      var s = (date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds());
      var df = Y + M + D + h + m + s;
      return df;
    },
  }
};
</script>
<style lang="scss" scoped>
.carPark-list {
  overflow: auto;
  color: #333;
}
.carPark-list {
  // background: #f8f8f8;
  box-sizing: border-box;
  // padding-top: 30px;
  .head_img {
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.order_item {
  width: 85%;
  // height: 160px;
  box-shadow: 0px 0px 10px #dedede;
  margin: 0 auto;
  border-radius: 2px;
  background-color: white;
  padding: 15px 20px 0px 20px;
  box-sizing: border-box;
  font-size: 12px;
  margin-top: 30px;
  overflow: hidden;

  .item_title {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
    .title_text {
      max-width: 260px;
      white-space: nowrap; /* 规定文本是否折行 */
      overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
      text-overflow: ellipsis;
    }
    .order_item_title {
      color: #262626;
      font-size: 16px;
      font-weight: 700;
    }
  }
  .item_content {
    .content_num,
    .content_parkName,
    .content_enterTime,
    .content_rule {
      padding-top: 12px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .left_text {
    display: inline-block;
    min-width: 60px;
  }
  .item_bottom {
    margin-top: 10px;
    color: #2eba73;
    padding-bottom: 20px;
    padding-top: 20px;
    border-top: 1px solid #f3f3f3;
    .bottom_show{
      color: #262626;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_search{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    img{
      width: 7px;
      height: 12px;
    }
  }
  .item_bottom_inPay {
    margin-top: 10px;
    color: #262626;
    font-size: 13px;
    font-weight: bold;
    // padding-bottom: 20px;
  }
  .order_action {
    width: 10px;
    height: 10px;
    padding: 0px 20px;

    img {
      width: 100%;
      height: 100%;
      transition: 0.2s;
    }
  }
  .foldBox {
    transition: 0.2s;
    // height: 150px;
    color: #787878;
    font-size: 13px;
  }
}
.empty_img {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  img {
    width: 70%;
    height: auto;
  }
  .empty_text {
    font-size: 13px;
    color: #ccc;
  }
}
</style>
